import {BackfillEventRequest} from 'src/openapi/models/BackfillEventRequest';
import {EventChangeRequest} from 'src/openapi/models/EventChangeRequest';

export const serializeAttributeTypeFields = (
    changeRequest: EventChangeRequest,
): BackfillEventRequest => ({
    ...changeRequest,
    eventCode: changeRequest.code,
    eventSource: changeRequest.source,
    eventType: changeRequest.type,
    attributes: changeRequest.attributes.map(attr => {
        const {fieldType, itemsType, ...baseAttr} = attr;

        return {
            ...baseAttr,
            ...(fieldType && {fieldType}),
            ...(itemsType && {itemsType}),
        };
    }),
}) as BackfillEventRequest;
